import clsx from "clsx";
import type { ReactNode } from "react";

import { DotmSquare11 } from "./ui/dotm-square-11";

import "./ExportOverlay.scss";

interface ExportOverlayProps {
  theme?: string;
  variant?: "spinner" | "dotmatrix";
  message?: ReactNode;
}

export const ExportOverlay = ({
  theme,
  variant = "spinner",
  message = "Exportando arquivo...",
}: ExportOverlayProps) => {
  return (
    <div
      className={clsx("ExportOverlay", {
        "ExportOverlay--dark": theme === "dark",
      })}
    >
      {variant === "dotmatrix" ? (
        <div className="ExportOverlay__loader" aria-hidden="true">
          <DotmSquare11 size={64} dotSize={7} speed={1.05} bloom />
        </div>
      ) : (
        <div className="ExportOverlay__spinner" aria-hidden="true" />
      )}
      <div className="ExportOverlay__text">{message}</div>
    </div>
  );
};
